import { createFileRoute } from "@tanstack/react-router";
import VerificareDealeri from "@/pages/incredere/VerificareDealeri";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/incredere/verificare-dealeri/")({
  head: () => routeHead("/incredere/verificare-dealeri/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <VerificareDealeri />
  );
}
